export default __webpack_public_path__ + "static/media/noun_Information_1415287.54642809.png";